
import LazyLoad from "react-lazyload";
import { Link } from 'react-router-dom'
import Breadcrumb from '../Component/Breadcrumb'
const OurPrincipals = () => {
    return (
        <>
        
        <Breadcrumb breadtitle="Our Principals" breadmid="Office Bearers" breadend="Our Principals" />
            <div className="innerpage">
                <div className="container">
                <div class="row">
        <div class="col-12">
        <h2 className='maintitle'>Canossa Girls Inter College</h2>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p4.jpg" />
            <h4>Sr. Victoria Alex</h4>
            <p class="text-center">(1998 - 1999)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p5.jpg" />
            <h4>Sr. Shanta Rose Sharma</h4>
            <p class="text-center">(1993 -1998)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p6.jpg" />
            <h4>Sr. Lucy Gonsalves</h4>
            <p class="text-center">(1999 - 2007)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p7.jpg" />
            <h4>Sr. Maxie Monteiro</h4>
            <p class="text-center">(2007 - 2010)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block ls-is-cached" src="https://webapi.entab.info/api/image/CSFL/public/images/p4.jpg" />
            <h4>Sr. Victoria Alex</h4>
            <p class="text-center">(2010 -2012)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img  alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p6.jpg" />
            <h4>Sr. Lucy Gonsalves</h4>
            <p class="text-center">(2012 - 2013)</p>
          </div>
        </div>
        <div class="col-12">
        <h2 className='maintitle'>Canossa School</h2>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img  alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p1.jpg" />
            <h4>Sr. Sunita Mao</h4>
            <p class="text-center">(2004 - 2012)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img  alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p2.jpg" />
            <h4>Sr. Alphonsa Joseph</h4>
            <p class="text-center">(2012 - 2017)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p3.jpg" />
            <h4>Sr. Lissy Mathew</h4>
            <p class="text-center">(2017 - 2021)</p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 ">
          <div class="princi-box">
            <img alt="Canossa School Lucknow" class="img-fluid mx-auto d-block" src="https://webapi.entab.info/api/image/CSFL/public/images/p8.jpg" />
            <h4>Sr. Rosy M. P.</h4>
            <p class="text-center">(Present)</p>
          </div>
        </div>
      </div>
                </div>
            </div>
        </>
    )
}

export default OurPrincipals
